import { Component, OnInit, Input, Output, EventEmitter, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { QuestionnaireService } from '../../services/questionnaire/questionnaire.service';
import moment from 'moment-timezone';
import {PermissionsService} from "../../services/permissions/permissions.service";

@Component({
  selector: 'app-insights-select-questionnaire',
  templateUrl: './insights-select-questionnaire.component.pug',
  styleUrls: ['./insights-select-questionnaire.component.scss'],
  standalone: false
})
export class InsightsSelectQuestionnaireComponent implements OnInit, OnChanges {
  @Input() questionnaireList: any;
  @Input() selectedTab: any;
  @Input() isDisabled: boolean=false;
  @Output() questionnairesSelected = new EventEmitter();
  @ViewChild('insightsDropdown') insightsDropdown: any;
  selectedQuestionnaires: any = [];
  currentSelection:any = [];
  surveyType: any;
  searchOption: any = undefined;
  searchOptions = [{'label':$localize`Survey`,'value':'title','hint':$localize`Survey title`}, {'label':$localize`Created by`,'value':'name','hint':$localize`First or last name`}];
  sortCriteria = {
    sortOptions: [
      {
        'label': $localize`Survey name`,
        'type': "word",
        'value': "title"
      },
      {
        'label': $localize`Created by`,
        'type': "word",
        'value': "name"
      },
      {
        'label': $localize`Times used`,
        'type': "number",
        'value': "count"
      },
    ],
    sortString: '-created',
    sortOrder: ''
  }
  paginationCriteria = {
    total: 0,
    rowsPerView: 20,
    currentPage: 1,
  }
  dropdownText = $localize`All`;
  lastSelected = '';
  requestExit = false;

  constructor(
    private questionnaireService: QuestionnaireService,
    private permissionsService: PermissionsService
  ) { }

  ngOnInit(): void {
    if (!this.permissionsService.hasPermission('can_view_exit_insights') &&
      !this.permissionsService.hasPermission('can_view_exit_insights_with_survey_perms'))
    {
      this.requestExit = true;
    }
    if(!this.requestExit){this.initialiseQuestionnaires();}
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.selectedTab.currentValue.toLowerCase()==='exits'){
      this.surveyType = 1
    }
  }

  onSearchChange(searchOutput){
    this.searchOption = searchOutput['data']['search'];
    this.initialiseQuestionnaires();
  }

  onSortChange(sortString:string): void {
    this.sortCriteria.sortString = sortString;
    this.initialiseQuestionnaires();
  }

  onPageChange(pageNumber) {
    this.paginationCriteria.currentPage = pageNumber;
    this.initialiseQuestionnaires();
  }

  onPageSizeChange(rowsPerView) {
    this.paginationCriteria.rowsPerView = rowsPerView;
    this.paginationCriteria.currentPage = 1;
    this.initialiseQuestionnaires();
  }

  selectedQuestionnaire(questionnaire) {
    if(this.currentSelection.includes(questionnaire['questionnaire'].id)){
      const index = this.currentSelection.indexOf(questionnaire['questionnaire'].id)
      this.currentSelection.splice(index, 1)
    }else{
      this.currentSelection.push(questionnaire['questionnaire'].id)
    }

    if (questionnaire.selected) {
      questionnaire.selected = false;
      this.selectedQuestionnaires = this.selectedQuestionnaires.filter(item => item !== questionnaire['questionnaire'].id)
    } else {
      questionnaire.selected = true;
      this.selectedQuestionnaires.push(questionnaire['questionnaire'].id)
    }
    if (this.selectedQuestionnaires.length === 1) {
      const index = this.currentSelection[0]
      const q =this.questionnaireList.find(item=>item['questionnaire'].id==index)
      if(q.selected==true){
        this.lastSelected = q.name
      }
    }
  }

  selectQuestionnaires() {
    this.insightsDropdown.hide();
    if (this.selectedQuestionnaires.length === 0) {
      this.dropdownText = $localize`All`
    }
    else if (this.selectedQuestionnaires.length === 1) {
      this.dropdownText = this.lastSelected;
    }
    else if (this.selectedQuestionnaires.length > 1) {
      this.dropdownText = this.selectedQuestionnaires.length + ' selected'
    }
    this.questionnairesSelected.emit(this.selectedQuestionnaires);
  }

  cancel() {
    this.insightsDropdown.hide();
  }
  initialiseQuestionnaires(){
    this.questionnaireService.getQuestionnairesDuplicateParams(this.searchOption, this.paginationCriteria.rowsPerView, this.paginationCriteria.currentPage, this.sortCriteria.sortString, null, this.surveyType).subscribe(
      (res) => {
        this.questionnaireList = res['data']['questionnaires'];
        this.paginationCriteria.total = res['data']['total'];
        this.formatDates();
      }, error => {
        console.log(error);
      });
  }

  formatDates() {
    this.questionnaireList.forEach(questionnaire => {
      if (this.currentSelection.includes(questionnaire['questionnaire'].id)){
        questionnaire.selected=true;
      }else{
        questionnaire.selected=false;
      }
      if (questionnaire['created']){
        questionnaire['created_formatted'] = moment(questionnaire['created']).format('ll');
      }
    });
  }

}
